import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import File from "./views/File.vue";
import files from "./doc/files";

Vue.use(Router);

const routes = files.map(file => ({
  name: file.name,
  path: `/${file.route}`,
  component: File
}));

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    ...routes
  ]
});

export default router;
